/**
 * Production-safe logger.
 *
 * In production (NODE_ENV === 'production') all methods are no-ops so nothing
 * is ever written to the browser console.  In development they proxy directly
 * to the native console so you keep full visibility.
 *
 * Usage:
 *   import logger from '../utils/logger';
 *   logger.log('something');
 *   logger.error('oops', err);
 */

const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

const logger = isProd
  ? {
      log:   noop,
      info:  noop,
      warn:  noop,
      error: noop,
      debug: noop,
    }
  : {
      log:   console.log.bind(console),
      info:  console.info.bind(console),
      warn:  console.warn.bind(console),
      error: console.error.bind(console),
      debug: console.debug.bind(console),
    };

export default logger;
